import { AppBar, Toolbar, Typography, IconButton, Avatar } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HomeIcon from '@mui/icons-material/Home';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface TopBarProps {
  onMenuClick: () => void;
}

export default function TopBar({ onMenuClick }: TopBarProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { mode, systemMode, setMode } = useColorScheme();
  const resolvedMode = (mode === 'system' ? systemMode : mode) || 'light';

  const toggleColorMode = () => {
    setMode(resolvedMode === 'dark' ? 'light' : 'dark');
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Toolbar>
        <IconButton edge="start" onClick={onMenuClick} sx={{ mr: 1 }}>
          <MenuIcon />
        </IconButton>
        <IconButton onClick={() => navigate('/')} sx={{ mr: 1 }}>
          <HomeIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
          Stash
        </Typography>
        <IconButton onClick={() => navigate('/ai')} sx={{ mr: 0.5 }}>
          <AutoAwesomeIcon />
        </IconButton>
        <IconButton onClick={toggleColorMode} sx={{ mr: 0.5 }}>
          {resolvedMode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
        <IconButton onClick={() => navigate('/search')} sx={{ mr: 1 }}>
          <SearchIcon />
        </IconButton>
        {user?.photoURL && (
          <Avatar
            src={user.photoURL}
            alt={user.displayName ?? ''}
            sx={{ width: 32, height: 32, cursor: 'pointer' }}
            onClick={() => navigate('/settings')}
          />
        )}
      </Toolbar>
    </AppBar>
  );
}
